
import React from 'react';
import _ from 'lodash';
import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import { FormFieldPanel } from './FormFieldPanel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { CircularProgressContainer } from '../others/CircularProgressContainer';

export const SectionPanel = props => {
  const { section, formik, updateOptionsCallback, yupRequiredFieldsCallback,
    bigFamilyCardCallback, updateDiscountsCallback, historicDataByPeselCallback,
    checkActivitiesCallback, setDateToCallback, hideFieldCallback, handleDiscountActions,
    handleParishChange, handleEventChange, handlePeriodChange, handleSourceOfOfferChange,
    handleOLDiscountActions, formVersion, params, boskieWakacje, allowMoreThan2PromotionsSelected,
    initialParamsData, formIdentifier, handleAccomodationChange, searchParams, events, sections,
    metaData, hideFieldsCallback, activeStep } = props;
  const [loading, setLoading] = React.useState(false);

  const setLoadingCallback = bool => setLoading(bool);

  const getFieldCallback = fieldName => _.find(section.fields, obj => {
    if (obj.name === fieldName) {

      return obj;
    }
  });

  const prepareYupRequiredFieldsCallback = (params, index, newVal) => {
    yupRequiredFieldsCallback(params, section.id, index, newVal);
  };

  const prepareBigFamilyCardCallback = (params, index) => {
    bigFamilyCardCallback(params, section.id, index);
  };

  const prepareUpdateDiscountsCallback = (discount, discountArr, latestId) => updateDiscountsCallback(discount, section.id, discountArr, latestId);

  const prepareHideFieldCallback = (fieldName, reverse = false, required = false) => {
    hideFieldCallback(fieldName, section.id, reverse, required);
  };

  const prepareHandleDiscountActions = (id, sections) => {
    handleDiscountActions(id, section.id, sections);
  };

  const prepareHandleOLDiscountActions = (id, sections) => {
    handleOLDiscountActions(id, section.id, sections);
  };

  const prepareHandleParishChange = id => {
    handleParishChange(id, section.id);
  };

  const prepareHandleEventChange = val => {
    handleEventChange(val, section.id);
  };

  const prepareHandlePeriodChange = (v, sections, initialization = false) => {
    handlePeriodChange(v, section.id, sections, initialization);
  };

  const prepareHandleSourceOfOfferChange = id => {
    handleSourceOfOfferChange(id, section.id);
  };

  const prepareHideFieldsCallback = (toHideFieldNames, toShowFieldNames, newSections, requiredHideFieldNames, requiredShowFieldNames) => {
    hideFieldsCallback(section.id, toHideFieldNames, toShowFieldNames, newSections, requiredHideFieldNames, requiredShowFieldNames);
  };

  if (boskieWakacje && section.fa_icon == 'users') {
    return null;
  }

  return (
    <Card
      style={{ marginRight: 7, marginLeft: 7, marginBottom: 10, opacity: loading ? 0.5 : 1, display: section.step == activeStep ? '' : 'none' }}
      elevation={4}>
      { section.title || section.fa_icon
        ? <CardHeader
          title={ section.icon_side === 'right'
            ? <Typography variant="h5">
              <b style={{ marginRight: '10px' }}>{section.title}</b>
            &nbsp;
              {!_.isEmpty(section.fa_icon)
                ? <FontAwesomeIcon
                  icon={['fas', section.fa_icon]}
                  color="white" />
                : null}
            </Typography>
            : <Typography variant="h5">
              {!_.isEmpty(section.fa_icon)
                ? <FontAwesomeIcon
                  icon={['fas', section.fa_icon]}
                  color="white" />
                : null
              }
            &nbsp;
              <b style={{ marginLeft: '10px' }}><span dangerouslySetInnerHTML={{ __html: section.title }}></span></b>
            </Typography>
          }
          style={{ backgroundColor: '#2494C6', paddingBottom: 20, color: 'white' }}
        />
        : null}
      <CardContent>
        {loading
          ? <CircularProgressContainer size={50} thickness={2.5} />
          : null}
        {_.map(section.fields, (obj, idx) => (
          <FormFieldPanel
            field={obj}
            key={idx}
            formik={formik}
            updateOptionsCallback={updateOptionsCallback}
            getFieldCallback={getFieldCallback}
            setLoadingCallback={setLoadingCallback}
            yupRequiredFieldsCallback={prepareYupRequiredFieldsCallback}
            bigFamilyCardCallback={prepareBigFamilyCardCallback}
            updateDiscountsCallback={prepareUpdateDiscountsCallback}
            historicDataByPeselCallback={historicDataByPeselCallback}
            checkActivitiesCallback={checkActivitiesCallback}
            setDateToCallback={setDateToCallback}
            hideFieldCallback={prepareHideFieldCallback}
            handleDiscountActions={prepareHandleDiscountActions}
            handleOLDiscountActions={prepareHandleOLDiscountActions}
            handleParishChange={prepareHandleParishChange}
            handleEventChange={prepareHandleEventChange}
            handlePeriodChange={prepareHandlePeriodChange}
            handleSourceOfOfferChange={prepareHandleSourceOfOfferChange}
            formVersion={formVersion}
            params={params}
            boskieWakacje={boskieWakacje}
            allowMoreThan2PromotionsSelected={allowMoreThan2PromotionsSelected}
            initialParamsData={initialParamsData}
            formIdentifier={formIdentifier}
            handleAccomodationChange={handleAccomodationChange}
            searchParams={searchParams}
            events={events}
            sections={sections}
            metaData={metaData}
            sectionId={section.id}
            hideFieldsCallback={prepareHideFieldsCallback}
          />
        ))}
      </CardContent>
    </Card>
  );
};
